import React from 'react';

const Vue_Scoped_Styling = () => {
  return (
    <div>
      <h1>Vue_Scoped_Styling Component</h1>
      <p>This is the Vue_Scoped_Styling tutorial page.</p>
    </div>
  );
}

export default Vue_Scoped_Styling;
